export const getBasename = (filePath) => {
    if (!filePath) return '';
    const parts = filePath.split('/');
    return parts[parts.length - 1] || '';
}

export const getExtname = (filePath) => {
    if (!filePath) return '';
    const basename = getBasename(filePath);
    const lastDot = basename.lastIndexOf('.');
    if (lastDot === -1 || lastDot === 0) return '';
    return basename.substring(lastDot);
}

export const getNextPageNumber = (next) => {
    if(next) {
        try {
            const url = new URL(next);
            const nextPageNumber = url.searchParams.get('page');
            return nextPageNumber;
        } catch (e) {
            const queryString = next.includes('?') ? next.split('?')[1] : next;
            const params = new URLSearchParams(queryString);
            return params.get('page');
        }
    }
}

export const daysEndingOfTheWordFilter = (n) => {
    if (n > 9 && n < 20) {
        return "gün";
    } else if (n > 100) {
        return "gün";
    } else {
        let lastChar = n  % 10;
        switch (lastChar) {
            case 0:
                return "gün";
            case 1:
                return "gün";
            case 2:
                return "gün";
            case 3:
                return "gün";
            case 4:
                return "gün";
            case 5:
                return "gün";
            case 6:
                return "gün";
            case 7:
                return "gün";
            case 8:
                return "gün";
            case 9:
                return "gün";
            default:
                return "gün";
        }
    }
}

export const daysEndingOfTheWord = (n) => {
    if (n > 9 && n < 20) {
        return "gün";
    } else {
        let lastChar = n  % 10;
        switch (lastChar) {
            case 0:
                return "gün";
            case 1:
                return "gün";
            case 2:
                return "gün";
            case 3:
                return "gün";
            case 4:
                return "gün";
            case 5:
                return "gün";
            case 6:
                return "gün";
            case 7:
                return "gün";
            case 8:
                return "gün";
            case 9:
                return "gün";
            default:
                return "gün";
        }
    }
}

export const hoursEndingOfTheWord = (n) => {
    if (n > 9 && n < 20) {
        return "saat";
    } else {
        let lastChar = n  % 10;
        switch (lastChar) {
            case 0:
                return "saat";
            case 1:
                return "saat";
            case 2:
                return "saat";
            case 3:
                return "saat";
            case 4:
                return "saat";
            case 5:
                return "saat";
            case 6:
                return "saat";
            case 7:
                return "saat";
            case 8:
                return "saat";
            case 9:
                return "saat";
            default:
                return "saat";
        }
    }
}

export const taskDeadlineCalculation = (hours) => {
    let days = Math.floor(hours / 24);
    let modulo = hours % 24;
    if (modulo > 0) {
        return `${days} ${daysEndingOfTheWord(days)} ${modulo} ${hoursEndingOfTheWord(modulo)}`;
    }
    return `${days} ${daysEndingOfTheWord(days)}`;
}

export const isOdd = (num) => {
    return (num % 2) === 1;
}

export const formatCardHolderName = (event) => {
    event.target.value = event.target.value.toUpperCase();
}

export const formatExpirationDate = (event) => {
    // https://codepen.io/stoXmod/pen/bGePmdd
    // let inputChar = String.fromCharCode(event.keyCode);
    let code = event.keyCode;
    let allowedKeys = [8];
    if (allowedKeys.indexOf(code) !== -1) {
        return;
    }

    event.target.value = event.target.value.replace(
        /^([1-9]\/|[2-9])$/g, '0$1/' // 3 > 03/
    ).replace(
        /^(0[1-9]|1[0-2])$/g, '$1/' // 11 > 11/
    ).replace(
        /^([0-1])([3-9])$/g, '0$1/$2' // 13 > 01/3
    ).replace(
        /^(0?[1-9]|1[0-2])([0-9]{2})$/g, '$1/$2' // 141 > 01/41
    ).replace(
        /^([0]+)\/|[0]+$/g, '0' // 0/ > 0 and 00 > 0
    ).replace(
        /[^\d/]|^[/]*$/g, '' // To allow only digits and `/`
    ).replace(
        /\/\//g, '/' // Prevent entering more than 1 `/`
    );
}

export const getCardType = (number) => {
    // visa
    const reVisa = new RegExp("^4");
    if (number.match(reVisa) != null)
        return "visa";

    // MIR
    const reMir = new RegExp("^220[0-4]");
    if (number.match(reMir) != null)
        return "mir";
    
    // Mastercard 1
    const reMastercardOne = new RegExp("^2[2-7][2-9]|2[3-7]");
    if (number.match(reMastercardOne) != null)
        return "mastercard";

    // Mastercard 2
    const reMastercardTwo = new RegExp("^5[1-5]");
    if (number.match(reMastercardTwo) != null)
        return "mastercard";

    return "visa";
}

export const isEllipsisActive = (e) => {
    const temp = e.cloneNode(true);

    temp.style.position = "fixed";
    temp.style.overflow = "visible";
    temp.style.whiteSpace = "nowrap";
    temp.style.visibility = "hidden";

    e.parentElement.appendChild(temp);

    try {
        const fullWidth = temp.getBoundingClientRect().width;
        const displayWidth = e.getBoundingClientRect().width;

        return fullWidth > displayWidth;
    } finally {
        temp.remove();
    }
}

export const numberWithSpaces = (nr) => {
	return nr.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export const tasksEndingOfTheWord = (n) => {
    if (n > 9 && n < 20) {
        return "tapşırıq";
    } else {
        let lastChar = n  % 10;
        switch (lastChar) {
            case 0:
                return "tapşırıq";
            case 1:
                return "tapşırıq";
            case 2:
                return "tapşırıq";
            case 3:
                return "tapşırıq";
            case 4:
                return "tapşırıq";
            case 5:
                return "tapşırıq";
            case 6:
                return "tapşırıq";
            case 7:
                return "tapşırıq";
            case 8:
                return "tapşırıq";
            case 9:
                return "tapşırıq";
            default:
                return "tapşırıq";
        }
    }
}

export const filesEndingOfTheWord = (num) => {
    switch (num) {
        case 0:
            return 'fayl';
        case 1:
            return 'fayl'; 
        case 2:
            return 'fayl';
        case 3:
            return 'fayl';
        case 4:
            return 'fayl';
        case 5:
            return 'fayl';
        default:
            return 'fayl';
    }
}

export const linksEndingOfTheWord = (num) => {
    switch (num) {
        case 0:
            return 'link';
        case 1:
            return 'link'; 
        case 2:
            return 'link';
        case 3:
            return 'link';
        case 4:
            return 'link';
        case 5:
            return 'link';
        default:
            return 'link';
    }
}

export const getNumberRatingReviews = (n) => {
    if (n > 9 && n < 20) {
        return "rəy";
    } else {
        let lastChar = n  % 10;
        switch (lastChar) {
            case 0:
                return "rəy";
            case 1:
                return "rəy";
            case 2:
                return "rəy";
            case 3:
                return "rəy";
            case 4:
                return "rəy";
            case 5:
                return "rəy";
            case 6:
                return "rəy";
            case 7:
                return "rəy";
            case 8:
                return "rəy";
            case 9:
                return "rəy";
            default:
                return "rəy";
        }
    }
}

const padTo2Digits = (num) => {
  return num.toString().padStart(2, '0');
}

export const formatDate = (_date) => {
    let _today = new Date();
    let today = [
        padTo2Digits(_today.getDate()),
        padTo2Digits(_today.getMonth() + 1),
        _today.getYear()-100,
    ].join('.');
    let date = [
        padTo2Digits(_date.getDate()),
        padTo2Digits(_date.getMonth() + 1),
        _date.getYear()-100,
    ].join('.');
    let time = [
        padTo2Digits(_date.getHours()),
        padTo2Digits(_date.getMinutes()),
        // padTo2Digits(_date.getSeconds()),
    ].join(':')
    return (`${date === today ? 'Bu gün' : date} ${time}`);
}

export const formatDateYear = (date) => {
    let parsedDate = new Date(date);
    return parsedDate.getFullYear();
}

export const formatBytes = (bytes, decimals = 2) => {
    if (!+bytes) return '0 Bytes'
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

export const trimFileName = (str) => {
    let [fileName, extension] = str.split('.');
    if (fileName.length > 7) {
        fileName = `${fileName.substring(0, 7)}...`;
    }
    return `${fileName}.${extension}`;
}

export const profileTimeUTC = (utc_offset) => {
    let now = new Date();
    let hours = now.getUTCHours() + Number(utc_offset) / 60;
    let minutes = now.getUTCMinutes();
    if (hours > 23) {
        hours -= 24;
    } else if (hours < 0) {
        hours += 24;
    }
    if (hours < 10) {
        hours = `0${hours}`;
    }
    if (minutes < 10) {
        minutes = `0${minutes}`;
    }
    return `${hours}:${minutes}`;
}